module.exports = "/images/link-google-drive.svg?91097f686729f790c23e360dbeeb5e64";